import Vue from 'vue'
import vueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(vueAxios,axios)

let http = axios.create({
    //开发时服务器作为代理使用
    //baseURL: '/api',
    //发布到服务器使用
    baseURL: '',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    transformRequest: [function (data) {
      let newData = '';
      for (let k in data) {
        if (data.hasOwnProperty(k) === true) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
        }
      }
      return newData;
    }]
  });
  
  function apiAxios(method, url, params, response) {
    http({
      method: method,
      url: url,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
    }).then(function (res) {
      response(res);
    }).catch(function (err) {
      response(err);
    })
  }
  
  export default {
    get: function (url, params, response) {
      return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
      return apiAxios('POST', url, params, response)
    },
    put: function (url, params, response) {
      return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
      return apiAxios('DELETE', url, params, response)
    }
  }


// WEBPACK FOOTER //
// ./src/api/index.js